// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"321":"a4437119","709":"8d28c8cc"}[chunkId] + ".chunk.js";
};